import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'

import ImagesComponent from '../../../../../components/ImagesRow'
import TeamContactsComponent from '../../../../../components/TeamContactsRow'

export const createCommunitySectionsConfig = (
  community,
  conditions,
  styles
) => {
  const socialNetworks = (() => [
    {
      key: 'discord',
      condition: conditions.hasDiscord,
      data: community?.socialNetworks?.discord,
    },
    {
      key: 'twitter',
      condition: conditions.hasTwitter,
      data: community?.socialNetworks?.twitter,
    },
    {
      key: 'facebook',
      condition: conditions.hasFacebook,
      data: community?.socialNetworks?.facebook,
    },
    {
      key: 'instagram',
      condition: conditions.hasInstagram,
      data: community?.socialNetworks?.instagram,
    },
  ])()

  return [
    {
      key: 'organizer-logo',
      condition: 'hasOrganizerLogo',
      component: ImagesComponent,
      props: {
        organizerLogo: true,
        images: community?.organizerLogo,
      },
    },
    {
      key: 'team-of-organizer',
      condition: 'hasTeamOfOrganizer',
      component: TeamContactsComponent,
      props: {
        teamOfOrganizer: true,
        information: community?.teamOfOrganizer,
      },
    },
    {
      key: 'contact',
      condition: 'hasContact',
      component: TeamContactsComponent,
      props: {
        contacts: true,
        information: community?.contact,
      },
    },
    {
      key: 'social-networks',
      wrapper: 'SectionWrapper',
      title: (
        <h4
          className={styles.events__about__title}
          data-testid='social-networks-title'
        >
          <FormattedMessage id='battlecup.information.social' />
        </h4>
      ),
      children: (
        <article
          className={classNames('eventBodyBg', styles.events__organizer__team)}
          data-testid='social-networks-section'
        >
          {socialNetworks.map(
            ({ key, condition, data }) =>
              condition && (
                <div
                  key={key}
                  className={styles.events__organizer__team__container}
                  data-testid={`${key}-link`}
                >
                  <h1 className={styles.organizer__card__title}>
                    {key.charAt(0).toUpperCase() + key.slice(1)} :
                  </h1>
                  <div className={styles.organizer__card}>
                    <a
                      href={data}
                      className={styles.organizer__card__title}
                      style={{ color: 'aqua' }}
                      target='_blank'
                    >
                      {data}
                    </a>
                  </div>
                </div>
              )
          )}
        </article>
      ),
    },
    {
      key: 'partner-logo',
      condition: 'hasPartnerLogo',
      component: ImagesComponent,
      props: {
        partnerLogo: true,
        images: community?.partnerLogo,
      },
    },
    {
      key: 'sponsor-logo',
      condition: 'hasSponsorLogo',
      component: ImagesComponent,
      props: {
        sponsorLogo: true,
        images: community?.sponsorLogo,
      },
    },
    {
      key: 'any-photos',
      condition: 'hasAnyPhotos',
      component: ImagesComponent,
      props: {
        anyPhotos: true,
        images: community?.anyPhotos,
      },
    },
  ]
}
